module.exports = __webpack_public_path__ + "img/C04TechImmortalS_ua.b690670a.webp";